<template>
  <div class="sm-billing-info__payment-details">
    <h4>Payment details</h4>
    <ul 
      v-if="provider.client_level == 3"
      class="sm-billing-info__payment-details-controls"
      :class="{
        'active-card': cardState
      }"
    >
      <li
        :class="{
          'active': cardState
        }"
        @click="cardState = true"
      >
        <span>Credit or debit card</span>
      </li>
      <li
        :class="{
          'active': !cardState
        }"
        @click="cardState = false"
      >
        <span>Bank Account</span>
      </li>
    </ul>

    <div
      v-if="cardState" 
      class="sm-billing-info__payment-details-card"
    >
      <div 
        v-if="defaultCreditCard"
        class="sm-billing-info__payment-details-card-radio"
      >
        <radiobutton-block
          :text="`Use default credit card`" 
          :name="'use_card'" 
          :checked="useDefaultCard"
          @input="useDefaultCard = true"
        />
        <radiobutton-block
          :text="`Enter new credit card`" 
          :name="'use_card'" 
          :checked="!useDefaultCard"
          @input="useDefaultCard = false"
        />
      </div>
      <default-card 
        v-if="useDefaultCard && defaultCreditCard"
        :card="defaultCreditCard"
      />
      <template v-else>
        <credit-card
          name="credit_card"
          v-model="card"
          v-validate="`required`"
          :error="errors.first('credit_card')"
        />
        <form-billing
          v-model="address"
          :account="userAccount"
        />
      </template>
    </div>
    <div
      v-else 
      class="sm-billing-info__payment-details-bank"
    >
      <bank-integration
        :linkToken="linkToken"
        @bankData="data => {$emit('bankData', handleBankData(data))}"
      />
    </div>

    <sm-spinner :show="!creditCards" />
  </div>
</template>

<script>
import CreditCard from '@/components/credit-card/CreditCard';
import FormBilling from '@/components/forms/FormBilling';
import BankIntegration from '@/components/bank-account/BankIntegration';
import { mapGetters } from 'vuex';
import Radiobutton from '@/components/Radiobutton';
import DefaultCard from '@/components/credit-card/DefaultCard';
import Spinner from '@/components/Spinner';

export default {
  name: 'payment-details',
  components: {
    'credit-card': CreditCard,
    'form-billing': FormBilling,
    'bank-integration': BankIntegration,
    'radiobutton-block': Radiobutton,
    'default-card': DefaultCard,
    'sm-spinner': Spinner
  },
  props: {
    initAddress: {
      type: Object,
      required: true
    },
    initCard: {
      type: Object,
      required: true
    },
    account: {
      type: Object,
      required: true
    },
    creditCards: {},
    bankAccount: {}
  },
  data() {
    return {
      cardState: true,
      address: {
        first_name: '',
        last_name: '',
        name: '',
        country: '',
        street: '',
        city: '',
        state: '',
        zip: ''
      },
      card: {
        number: '',
        expiration: {
          month: '',
          year: ''
        },
        cvc: ''
      },
      userAccount: {},
      useDefaultCard: true
    }
  },
  computed: {
    ...mapGetters({
      provider: 'provider'
    }),
    defaultCreditCard() {
      if (!this.creditCards)
        return null;

      return this.creditCards.find(card => card.default);
    },
    linkToken() {
      if (!this.bankAccount || !this.bankAccount.link)
        return '';
        
      return this.bankAccount.link.link_token;
    }
  },
  created() {
    this.userAccount = Object.assign({}, this.account);
    this.address = this.initAddress;
    this.card = this.initCard;
  },
   methods: {
    handleBankData(data) {
      if (!data)
        return {
          plaid_public_token: '',
          plaid_account_id: '' 
        };

      let accID = data.account_id;

      if (!accID)
        accID = data.account.id;

      if (!accID && data.accounts.length)
        accID = data.accounts[0].id; // TEMP?

      if (!accID)
        return; // handling

      return {
        plaid_public_token: data.public_token,
        plaid_account_id: accID 
      }
    }
  },
  watch: {
    address: {
      deep: true,
      handler(val) {
        this.$emit('address', val);
      }
    },
    card: {
      deep: true,
      handler(val) {
        this.$emit('card', val);
      }
    },
    useDefaultCard(val) {
      this.$emit('changeDefault', val);
    },
    cardState(val) {
      this.$emit('cardState', val);
    }
  }
}
</script>